import { html } from 'fxjs/es';
import { MShopCoreTmplS } from '../../../../MShop/Core/S/Tmpl/module/MShopCoreTmplS.js';

export const cartButton = (cart_count, brand_color) => html` <a
  href="/${T.lang}/@/cart"
  class="creator-header__button creator-header__button--cart"
>
  <div
    class="creator-header__text-box
       ${cart_count > 9 ? 'creator-header__text-box--wide' : ''}
       ${cart_count > 0 ? 'creator-header__text-box--show' : ''}"
    style="background-color: ${brand_color};"
  >
    <span class="creator-header__text creator-header__text--cart">${cart_count}</span>
  </div>
</a>`;

export const tmpl = ({ locals: { plus_crew }, body, footerHidden, isLayoutMargin, isHome = false }) => {
  return html`
    <div class="creator-layout ${isLayoutMargin ? 'creator-layout--is-margin' : ''}">
      <div class="creator-layout__inner ${isHome ? 'creator-layout--is-home' : ''}">
        <div class="creator-layout__body">${body}</div>
      </div>
      <button class="creator-layout__up">
        <span class="creator-layout__blind"> 페이지 상단으로 이동하기 </span>
      </button>
      ${footerHidden ? '' : MShopCoreTmplS.createDefaultFooter(plus_crew)}
    </div>
  `;
};
